import { products as importProducts } from './products-gentux';
export const products = importProducts;
